<template>
  <section class="timeTplCaseDetail p-4">
    <section>
      <viewTitle
        title="业务管理 / 基础数据管理 / 预约时间实例 / 查看实例详情"
        :showReturn="true"
      />
    </section>

    <div class="main">
      <el-form label-width="145px" label-position="left">
        <el-form-item label="模板名称">
          {{ timeTpObj.modelName || "--" }}
        </el-form-item>
        <el-form-item label="实例时间">
          {{ formatTime(timeTpObj.bookingDay) || "--" }}
        </el-form-item>
        <el-form-item label="已预约总量">
          {{ useTotalNumber || "--" }}
        </el-form-item>
        <el-form-item label="已预约汇总">
          <div class="sourceResult">
            <template v-for="(item, index) in useTotalNumberText">
              <div :key="index" type="info">
                <span>{{ item.group_name }}</span>
                <span>（{{ item.used_number }}/{{ item.total_number }}）</span>
              </div>
            </template>
            <template v-if="JSON.stringify(useTotalNumberText) === '{}'">
              --
            </template>
          </div>
        </el-form-item>
        <el-form-item label="每日号源划分">
          <div class="sourceResult">
            <template v-for="(item, index) in timeTpObj.daySource">
              <div :key="index" type="info">
                <div v-for="(group, index) in item.number" :key="index">
                  <span :style="{ opacity: index == 0 ? 1 : 0 }">[ {{ item.begin_time }} ~ {{ item.end_time }} ]</span>
                  <span>{{ group.group_name }}</span>
                  <span>（{{group.used_number}} / {{ Number(group.total_number) == 0 ? "不限" : group.total_number }}）</span>
                  <template v-if="!Array.isArray(group.detail) && getGrouoItem(group.group_id)">
                    <span style="display: block" v-for="(car, ind) in getGrouoItem(group.group_id).sub_business_list" :key="car.id">
                    <span style="opacity: 0;user-select: none;">[ {{ item.begin_time }} ~ {{ item.end_time }} ] </span>
                      <span v-if="group.detail[car.id]">
                        {{ car.name }}：{{group.detail[car.id].used_number || 0}} / {{ group.detail[car.id].total_number == -1 ? '不限' : group.detail[car.id].total_number }}
                      </span>
                    <span v-else>{{ car.name }}：0 / 不限</span>
                  </span>
                  </template>
                </div>
              </div>
            </template>
            <template v-if="timeTpObj.daySource.length === 0">
              --
            </template>
          </div>
        </el-form-item>
        <el-form-item label="排队登记可延迟时间">
          <span>{{ timeTpObj.model_info.check_effectivity_time }}小时</span>
        </el-form-item>
        <el-form-item label="叫号后过期时间">
          <span>{{ timeTpObj.model_info.calling_effectivity_time }}分钟</span>
        </el-form-item>
        <el-form-item label="最小可预约时间">
          <span v-if="dataArr.min_booking_time > 0">
            {{ formatMin(timeTpObj.minRangKey) || "--" }}</span
          >
          <span v-else>无限制</span>
        </el-form-item>
        <el-form-item label="最大可预约时间">
          {{ maxRangKeyDesc || "--" }}
        </el-form-item>
        <el-form-item label="使用状态">
          <template>
            <span v-if="Number(timeTpObj.useState) == 1" class="color67"
              >未使用</span
            >
            <span v-else-if="Number(timeTpObj.useState) == 2" class="color5E"
              >已使用</span
            >
            <span v-else-if="Number(timeTpObj.useState) == 3" class="color99"
              >已过期</span
            >
            <span v-else>--</span>
          </template>
        </el-form-item>
        <el-form-item label="创建日期">
          {{ timeTpObj.create_time }}
        </el-form-item>
        <el-form-item label="最后更新日期">
          {{ timeTpObj.update_time }}
        </el-form-item>
      </el-form>
      <div
        style="margin: 30px 0px 11px;"
        v-if="Number(timeTpObj.useState) !== 3"
      >
        <el-button v-has="['c-base-mp-itime-update']" type="primary" @click="editTimeTp" size="small">
          编 辑
        </el-button>
      </div>

      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>模板名称：</span></el-col>
        <el-col :span="14">
          <span>{{ timeTpObj.modelName }}</span>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>实例时间：</span></el-col>
        <el-col :span="14">
          <span>{{ timeTpObj.bookingDay }}</span>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>已预约总量：</span></el-col>
        <el-col :span="14">
          <span>{{ useTotalNumber }}</span>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>已预约汇总：</span></el-col>
        <el-col :span="14">
          <span>
            <div>
              <div class="sourceResult">
                <template v-for="(item, index) in useTotalNumberText">
                  <el-tag :key="index" type="info">
                    <span>{{ item.group_name }}</span>
                    <span
                      >({{ item.used_number }}/{{ item.total_number }})</span
                    >
                  </el-tag>
                </template>
              </div>
            </div>
          </span>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>每日号源划分：</span></el-col>
        <el-col :span="14">
          <div class="">
            <div class="sourceResult">
              <template v-for="(item, index) in timeTpObj.daySource">
                <el-tag :key="index" type="info">
                  <span>[{{ item.begin_time }} ~ {{ item.end_time }}]</span>
                  <span v-for="(group, index) in item.number" :key="index">
                    <span>{{ group.group_name }}</span>
                    <span
                      >({{ group.used_number }}/{{
                        Number(group.total_number) == 0 ? "不限" : group.number
                      }})</span
                    >
                  </span>
                </el-tag>
              </template>
            </div>
          </div>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>最小可预约时间：</span></el-col>
        <el-col :span="14">
          <span> {{ minRangKeyDesc }}</span>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>最大可预约时间：</span></el-col>
        <el-col :span="14">
          <span>{{ maxRangKeyDesc }}</span>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>使用状态：</span></el-col>
        <el-col :span="14">
          <template>
            <span v-if="Number(timeTpObj.useState) == 1">未使用</span>
            <span v-else-if="Number(timeTpObj.useState) == 2">已使用</span>
            <span v-else-if="Number(timeTpObj.useState) == 3">已过期</span>
            <span v-else>--</span>
          </template>
        </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>创建日期：</span></el-col>
        <el-col :span="14"> {{ timeTpObj.create_time }}</el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span>最后更新日期：</span></el-col>
        <el-col :span="14"> {{ timeTpObj.update_time }} </el-col>
      </el-row> -->
      <!-- <el-row type="flex" align="middle" :gutter="10">
        <el-col :span="4"><span></span></el-col>
        <el-col :span="14">
          <el-button type="primary" @click="editTimeTp">编辑</el-button>
          <el-button @click="backList">返回</el-button>
        </el-col>
      </el-row> -->
    </div>
  </section>
</template>
<script>
import viewTitle from "@/components/viewTitle";
// import confirm from "@/components/elementPlus/packages/confirm";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      carTypes: [
        { name: "平板车", key: "flatTruck" },
        { name: "货柜车", key: "containerTruck" },
        { name: "槽罐车", key: "tankTruck" },
        { name: "高栏车", key: "highSidedTruck" },
        { name: "其他", key: "orderTruck" }
      ],
      timeTpObj: {
        name: "",
        timeType: "",
        timeRang: [],
        delDay: [],
        addDay: [],
        checkList: [],
        minRangList: [
          {
            value: "0",
            label: "0分钟 无时间限制"
          },
          {
            value: "1800",
            label: "不小于30分钟"
          },
          {
            value: "3600",
            label: "不小于1小时"
          },
          {
            value: "7200",
            label: "不小于2小时"
          },
          {
            value: "10800",
            label: "不小于3小时"
          },
          {
            value: "14400",
            label: "不小于4小时"
          },
          {
            value: "18000",
            label: "不小于5小时"
          }
        ],
        maxRangList: [
          {
            value: "1",
            label: "1天内"
          },
          {
            value: "2",
            label: "2天内"
          },
          {
            value: "3",
            label: "3天内"
          },
          {
            value: "7",
            label: "7天内"
          },
          {
            value: "15",
            label: "15天内"
          },
          {
            value: "30",
            label: "30天内"
          }
        ],
        options: [],
        textarea: "",
        minRangKey: "",
        maxRangKey: "",
        daySource: [],
        model_info: {}
      },
      businessList: [],
      dataArr: {}
    };
  },
  watch: {},
  components: { viewTitle },
  computed: {
    getGrouoName() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item.name;
          }
        }
      };
    },
    getGrouoItem() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item;
          }
        }
      };
    },
    // 最小时间
    // minRangKeyDesc() {
    //   let text = "";
    //   this.timeTpObj.minRangList.forEach(item => {
    //     if (Number(this.timeTpObj.minRangKey) == Number(item.value)) {
    //       text = item.label;
    //       console.log(text, "dddd");
    //     }
    //   });
    //   return text;
    // },
    maxRangKeyDesc() {
      let text = "";
      this.timeTpObj.maxRangList.forEach(item => {
        if (Number(this.timeTpObj.maxRangKey) == Number(item.value)) {
          text = item.label;
        }
      });
      return text;
    },
    useTotalNumber() {
      let sum = 0;
      this.timeTpObj.daySource.forEach(item => {
        item.number.forEach(el => {
          sum += Number(el.used_number);
        });
      });
      return sum;
    },
    useTotalNumberText() {
      let useObj = {};
      this.timeTpObj.daySource.forEach(item => {
        item.number.forEach(el => {
          let totalNumberAdd = true;
          if (Number(el.total_number) == 0) {
            totalNumberAdd = false;
          }
          if (useObj[el.group_id]) {
            useObj[el.group_id].used_number += Number(el.used_number);
            if (!totalNumberAdd || useObj[el.group_id].total_number == "不限") {
              useObj[el.group_id].total_number = "不限";
            } else {
              useObj[el.group_id].total_number += Number(el.total_number);
            }
          } else {
            useObj[el.group_id] = {
              group_name: el.group_name,
              used_number: Number(el.used_number)
            };
            if (!totalNumberAdd) {
              useObj[el.group_id].total_number = "不限";
            } else {
              useObj[el.group_id].total_number = Number(el.total_number);
            }
          }
        });
      });
      return useObj;
    }
  },
  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    editTimeTp() {
      this.$router.push({
        path: "/rhqy/service/appoint/timeCaseList/modify/" + this.timeTpObj.id
      });
    },

    backList() {
      this.$router.go(-1);
    },
    getInitData(id) {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_time_instance_detail",
          data: {
            id
          }
        })
        .then(res => {
          console.log(res);
          const data = res.data.data;
          this.dataArr = data;
          this.timeTpObj.id = data.id;
          this.timeTpObj.modelName = data.model_name;
          this.timeTpObj.model_info = data.model_info;
          this.timeTpObj.bookingDay = data.booking_day;
          // this.timeTpObj.name = data.name;
          // this.timeTpObj.timeType = data.is_permanent_valid.toString();
          // if (data.is_permanent_valid.toString() == "2") {
          //   this.timeTpObj.timeRang = [
          //     data.begin_time.toString(),
          //     data.end_time.toString()
          //   ];
          // } else {
          //   this.timeTpObj.timeRang = [];
          // }
          // this.timeTpObj.holidayType = data.is_use_statutory_holidays.toString();
          // this.timeTpObj.addDay = data.exclude_day;
          // this.timeTpObj.delDay = data.extra_day;
          // this.timeTpObj.checkList = data.repeat_setting;
          this.timeTpObj.minRangKey = data.min_booking_time.toString();
          this.timeTpObj.maxRangKey = data.max_booking_day.toString();
          // this.timeTpObj.textarea = data.note;
          this.timeTpObj.daySource = data.periods;
          this.timeTpObj.create_time = this.formatTime(data.create_time);
          this.timeTpObj.update_time = this.formatTime(data.update_time);
          // this.timeTpObj.valid_state = data.valid_state;
          this.timeTpObj.useState = data.use_state;
          // this.timeTpObj.used_instance_num = data.used_instance_num;
          // this.timeTpObj.instance_num = data.instance_num;
          // this.timeTpObj.history_num = data.history_num;
        });
    },
    getBusinessList() {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_group",
          data: {
            keyword: "",
            state: 1,
            page_size: 1000
          }
        })
        .then(res => {
          this.businessList = res.data.data.data;
        });
    },
    // 格式化最小可预约时间
    formatMin(str) {
      if (str === 0) {
        return `无限制`;
      } else {
        return `不小于${parseFloat((str / 60 / 60).toFixed(2))}小时`;
      }
    }
  },
  created() {
    this.getBusinessList();
    if (this.$route.params.id) {
      this.getInitData(this.$route.params.id);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.timeTplCaseDetail {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  .main {
    padding: 5px 16px;
    .el-row {
      padding-bottom: 18px;
    }
    .el-col-4 {
      text-align: right;
    }
    .elRadio1 {
      width: 70px;
    }
    .el-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }
    .addDay {
      color: #409eff;
      font-size: 20px;
      cursor: pointer;
    }
    .c4b {
      padding: 10px 10px 5px 10px;
      border: 1px solid #cecece;
    }
    .full100 {
      display: flex;
      align-items: center;
      .w100 {
        width: 100%;
      }
    }
    .dayDiv {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .el-select {
      width: 100%;
    }
    .sourceResult {
      .desc {
        display: inline-block;
        padding-bottom: 10px;
      }
      .el-tag {
        display: inline-block;
        white-space: normal;
        height: auto;
        line-height: 17px;
        padding: 5px 28px 5px 8px;
        position: relative;
        width: 100%;
      }
    }
  }
  .elDialog {
    .el-row {
      padding-bottom: 18px;
    }
    .divRow {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .el-radio {
        margin-right: 10px;
      }
      .el-select {
        width: 200px;
        margin-right: 10px;
      }
      .el-input {
        width: 100px;
        margin-right: 10px;
      }
    }
    .el-col-4 {
      text-align: right;
    }
    .plus {
      color: #409eff;
      cursor: pointer;
    }
    .close {
      color: coral;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.timeTplCaseDetail {
  .el-date-editor .el-range-separator {
    line-height: 24px;
  }
  .sourceResult {
    .el-tag {
      .el-icon-close {
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
        position: absolute;
      }
    }
  }
  .delDayTimePlugin,
  .addDayTimePlugin {
    width: 0;
    opacity: 0;
    > input {
      border: 0 !important;
      padding: 0;
    }
  }
  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
